import { lazy } from "react";
import { Route } from "react-router";

import { RouteGuardApplicationRights } from "components/routes/RouteGuardApplicationRights";
import { LazyRouteElement } from "components/routes/LazyRouteElement";
import Layout from "components/layout/Layout";
import { Module } from "./Module";

const QuayLocationsOverviewLazy = lazy(() =>
    import("./pages/QuayManualLocationsOverview").then((module) => ({
        default: module.QuayLocationsOverview,
    })),
);
const QuayProximityOverviewLazy = lazy(() =>
    import("./pages//QuayManualLocationsProximityOverview").then((module) => ({
        default: module.QuayLocationsProximityOverview,
    })),
);
const QuayManualLocationLazy = lazy(() =>
    import("./pages/QuayManualCardOverview").then((module) => ({ default: module.QuayManualCardOverview })),
);

export function Routes() {
    return (
        <>
            <Route
                key="quaymanuals-locations-overview"
                path="/quaymanuals"
                element={
                    <Layout>
                        <RouteGuardApplicationRights requiredApplicationRights={Module.applicationRights}>
                            <LazyRouteElement fallback={null}>{<QuayLocationsOverviewLazy />}</LazyRouteElement>
                        </RouteGuardApplicationRights>
                    </Layout>
                }
            />
            <Route
                key="quaymanuals-proximity"
                path="/quaymanuals/:id/proximity"
                element={
                    <Layout>
                        <RouteGuardApplicationRights requiredApplicationRights={Module.applicationRights}>
                            <LazyRouteElement fallback={null}>{<QuayProximityOverviewLazy />}</LazyRouteElement>
                        </RouteGuardApplicationRights>
                    </Layout>
                }
            />
            <Route
                key="quaymanuals-location"
                path="/quaymanuals/:id"
                element={
                    <Layout>
                        <RouteGuardApplicationRights requiredApplicationRights={Module.applicationRights}>
                            <LazyRouteElement fallback={null}>{<QuayManualLocationLazy />}</LazyRouteElement>
                        </RouteGuardApplicationRights>
                    </Layout>
                }
            />
        </>
    );
}
